module.exports = "../study/imgs/maps/Kanagawa/S8/Ecosystem/Fagus/Kanagawa_Fagus_MIROC5_RCP26_Now.png";